// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__jX2_r","newExpiryDate":"styles_newExpiryDate__3OnTX","footer":"styles_footer__3ShwR"};